import React from 'react';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import Lang from '../../lang'
import { Button } from '@progress/kendo-react-buttons';
import $ from 'jquery';




class GoogleMapPopUp extends React.Component {
    closePopup = () => {
        try {
            if (this.props.closePopup) {
                this.props.closePopup();
            } else {
                $(".close").trigger('click');
            }
        } catch (error) {
            this.setState({error})
        }
    }
    render() {
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title w-100">{Lang.langCheck.langRequest("Ver no mapa")}</h4>
                    <Button onClick={() => this.closePopup()} className="close" data-dismiss="modal">&times;</Button>
                </div>

                <div className="modal-body text-center">
                    <Map google={this.props.google} zoom={14}>

                        <Marker onClick={this.onMarkerClick}
                            name={'Current location'} />

                        <InfoWindow onClose={this.onInfoWindowClose}>
                            <div>
                                {/* <h1>{this.state.selectedPlace.name}</h1> */}
                                <hi>{123}</hi>
                            </div>
                        </InfoWindow>
                    </Map>
                </div>
            </div>
        )
    }
}


export default GoogleApiWrapper({
    apiKey: "AIzaSyBMxYM2_HBPV0WrUbM4DVzlx4JzWe1LFSo"
  })(GoogleMapPopUp)
  